import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export class Option extends PureComponent {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
  }

  focus() {
    this.input.focus();
  }

  render() {
    const { id, text, checked, className, value, onChange, type, tabIndex, ...others } = this.props;

    return (
      <label className={`pxl-option pxl-option--${type} ${className}`}>
        <input
          id={id}
          type="checkbox"
          onChange={onChange.bind(null, value)}
          value={value}
          checked={checked}
          tabIndex={tabIndex}
          className={`pxl-option__input`}
          {...others}
          ref={input => {
            this.input = input;
          }}
        />
        <div className="pxl-option__text" dangerouslySetInnerHTML={{ __html: text }} />
      </label>
    );
  }
}

Option.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.any,
  name: PropTypes.string,
  onChange: PropTypes.func,
  tabIndex: PropTypes.number,
  text: PropTypes.any,
  type: PropTypes.oneOf(['pills', 'checklist', 'radio']),
  value: PropTypes.any
};

Option.defaultProps = {
  tabIndex: 0,
  type: 'checklist'
};

export default Option;
